<template>
  <div id="mainLayout">
    <inviteHeader v-if="$route.meta.showInviteHeader"></inviteHeader>
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  components: {
    inviteHeader: () => import('../components/inviteHeader'),
  },
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>
<style scoped lang="less">
#mainLayout {
  height: 100%;
}
</style>
